// extracted by mini-css-extract-plugin
module.exports = {"rigsList":"RentalRigs_rigsList__kONoh","rigItem":"RentalRigs_rigItem__ulzY3"};